export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const parts = [
    h > 0 ? String(h).padStart(2, '0') : '00',
    String(m).padStart(2, '0'),
    String(s).padStart(2, '0'),
  ];
  return parts.join(':');
}

export function formatDistance(km: number): string {
  return `${km.toFixed(1)} km`;
}
